<div class="app-content">
  <slb-button-group [align]="'start'">
    <button slb-button (click)="sayHello('toast')" title="toast">Say Hello</button>
    <button slb-secondary-button (click)="sayHello('banner')" title="banner">Say Hello</button>
    <button slb-tertiary-button (click)="sayHello('modal')" title="modal">Say Hello</button>
  </slb-button-group>
</div>
